export default "__VITE_ASSET__BfzvVSqY__";